module.exports = __webpack_public_path__ + "img/swiper_03.d0f3bde3.jpg";